import { Component as ComponentContainer } from '@styles/layout';
import { InformationComponent } from '@model/content';
import { MediaEnquiries } from '@components/help';

export const MediaEnquiriesContainer = (props: InformationComponent) => {
  return (
    <ComponentContainer>
      <MediaEnquiries {...props} />
    </ComponentContainer>
  );
};
